import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { P0003601EnSavoirPlusComponent } from '../../../../P0003601/EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import { FunctionParametersSettingClockWeekVSScreenComponent } from '../../../../P0003601/Component/function-parameters-setting-clock-week-vsscreen/function-parameters-setting-clock-week-vsscreen.component';
import { FunctionParametersSettingClockVSScreenComponent } from '../../../../P0003601/Component/function-parameters-setting-clock-vsscreen/function-parameters-setting-clock-vsscreen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { P00058EnSavoirPlusComponent } from '../../../EnSavoirPlus/p00058-en-savoir-plus/p00058-en-savoir-plus.component';
import { P00058ProgrammeFiltrationAuto } from '../../../Enum/P00058ProgrammeFiltrationAuto';
import { P00058SeuilTemperatureFiltration2424 } from '../../../Enum/P00058SeuilTemperatureFiltration2424';
import { P00058BathingTimerEnum } from '../../../Enum/P00058BathingTimerEnum';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P00058EcremageTimerEnum } from '../../../Enum/P00058EcremageTimerEnum';
import { P00058AmorcageTimerEnum } from '../../../Enum/P00058AmorcageTimerEnum';
import { P00058SpeedEnum } from '../../../Enum/P00058SpeedEnum';
import { FunctionParametersSettingsClockPompeVSScreenComponent } from '../../../Component/function-parameters-settings-clock-pompe-vsscreen/function-parameters-settings-clock-pompe-vsscreen.component';
import { FunctionParametersSettingClockWeekPompeVSScreenComponent } from '../../../Component/function-parameters-setting-clock-week-pompe-vsscreen/function-parameters-setting-clock-week-pompe-vsscreen.component';

@Component({
  selector: 'app-p00058-pompe-mise-en-oeuvre-programme',
  templateUrl: './p00058-pompe-mise-en-oeuvre-programme.component.html',
  styleUrls: ['./p00058-pompe-mise-en-oeuvre-programme.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
    SwitchConfigurationComponent,
  ],
})
export class P00058PompeMiseEnOeuvreProgrammeComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  public translateService: TranslateService = inject(TranslateService);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
    this.openEnSavoirPlus2 = this.openEnSavoirPlus2.bind(this);
  }

  getAmorcageTimerEnum() {
    return P00058AmorcageTimerEnum(this.translateService);
  }
  getSpeedEnum(min: number, max: number) {
    return P00058SpeedEnum(
      this.translateService,
      this.actionStack!.getValue('pvPUniteConsignePompe'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      min,
      max,
      5,
      this.actionStack!.getValue('pvSVitesseMinRpm'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      100,
    );
  }

  async openEnSavoirPlus2() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00058.installation.bathing.enSavoirPlus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalController.create({
      component: P00058EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  getBathingTimer() {
    return P00058BathingTimerEnum(this.translateService);
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingClockWeekPompeVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvPHorlogeSemaineHivers'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage10,
        'pvPHorlogeSemaineHivers',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingsClockPompeVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('pvPHorlogeJourHiversLundi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversMardi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversMercredi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversJeudi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversVendredi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversSamedi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversDimanche'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage11,
        'pvPHorlogeJourHiversLundi',
        hj.substring(0, 96),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage12,
        'pvPHorlogeJourHiversMardi',
        hj.substring(96, 192),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage13,
        'pvPHorlogeJourHiversMercredi',
        hj.substring(192, 288),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage14,
        'pvPHorlogeJourHiversJeudi',
        hj.substring(288, 384),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage15,
        'pvPHorlogeJourHiversVendredi',
        hj.substring(384, 480),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage16,
        'pvPHorlogeJourHiversSamedi',
        hj.substring(480, 576),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage17,
        'pvPHorlogeJourHiversDimanche',
        hj.substring(576, 672),
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekPPEScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingClockWeekPompeVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvPHorlogeSemaineEte'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage2,
        'pvPHorlogeSemaineEte',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingsClockPEEScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingsClockPompeVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('pvPHorlogeJourEteLundi') +
          this.actionStack!.getValue('pvPHorlogeJourEteMardi') +
          this.actionStack!.getValue('pvPHorlogeJourEteMercredi') +
          this.actionStack!.getValue('pvPHorlogeJourEteJeudi') +
          this.actionStack!.getValue('pvPHorlogeJourEteVendredi') +
          this.actionStack!.getValue('pvPHorlogeJourEteSamedi') +
          this.actionStack!.getValue('pvPHorlogeJourEteDimanche'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage3,
        'pvPHorlogeJourEteLundi',
        hj.substring(0, 96),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage4,
        'pvPHorlogeJourEteMardi',
        hj.substring(96, 192),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage5,
        'pvPHorlogeJourEteMercredi',
        hj.substring(192, 288),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage6,
        'pvPHorlogeJourEteJeudi',
        hj.substring(288, 384),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage7,
        'pvPHorlogeJourEteVendredi',
        hj.substring(384, 480),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage8,
        'pvPHorlogeJourEteSamedi',
        hj.substring(480, 576),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage9,
        'pvPHorlogeJourEteDimanche',
        hj.substring(576, 672),
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00058ProgrammeFiltrationAuto =
    P00058ProgrammeFiltrationAuto;
  protected readonly P00058SeuilTemperatureFiltration2424 =
    P00058SeuilTemperatureFiltration2424;
}
